
import { Component, Prop, Vue } from 'vue-property-decorator'
import { LearningProgressList } from '@/models/manage/LearningProgressList'

/**
 * 通常学習進捗比較テーブル
 */
@Component
export default class CompareLearningProgressTable extends Vue {
  /** 通常学習進捗集計データ一覧 */
  @Prop()
  private summaryProgressList!: LearningProgressList.Table[]

  /**
   * 棒グラフのスタイルを設定する
   *
   * @param value 進捗率(%)
   * @param color 色指定
   * @returns cssスタイル指定
   */
  private setChartBarStyle(value: number, color: string): { [key: string]: string } {
    return {
      '--bar-width': `${value / 100}`,
      '--chart-color': `var(${color})`,
    }
  }

  /**
   * 学習進捗一覧の最後の要素であるか判定
   *
   * @param index インデックス
   * @returns 最後の要素ならtrue
   */
  private lastIndex(index: number): boolean {
    return index + 1 === this.summaryProgressList.length
  }
}
